<template>
    <div class="flex justify-content-end gap-2 mt-2 sm:flex-wrap-reverse">
        <div class="flex gap-2">
            <Dropdown id="typeSelector" v-model="selectedType" :options="getAllTypeSelectors()" optionLabel="name" optionValue="value" placeholder="Add inner elements" class="w-full md:w-14rem" />
            <Button icon="pi pi-plus" @click="addSelectedType" />
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps } from 'vue';

import { useDataSourceStore } from '../store';
import { getAllTypeSelectors } from '../enum-helpers';
import { showToast } from '@/helpers/toast-handler';

const dataSourceStore = useDataSourceStore();

const props = defineProps({
    linkKey: {
        type: [String],
    },
});
const selectedType = ref(null);

const addSelectedType = () => {
    if (selectedType.value) {
        dataSourceStore.addSelectedLinkType(props.linkKey, selectedType.value);
    } else {
        showToast({ severity: 'info', summary: 'No Option' }, 'Select an option first');
    }
};
</script>
